<template>
  <section class="orders-container">
    <header>
      <div class="list-header">
        <span @click="onSort('date')" class="col-date clickable">Datum</span>
        <span @click="onSort('orderNumber')" class="col-ordernr clickable"
          >Ordernr.</span
        >
        <span @click="onSort('project')" class="col-project clickable"
          >Project</span
        >
        <span @click="onSort('reference')" class="col-reference clickable"
          >Referentie</span
        >
        <span @click="onSort('product')" class="col-product clickable"
          >Product</span
        >
        <span @click="onSort('state')" class="col-state clickable">Status</span>
        <span class="col-btn"></span>
      </div>
    </header>

    <main id="scroll-list" class="table-container">
      <section class="pre-loader" v-if="loading">
        <p>Uw opdrachten worden geladen.</p>
        <bouncing-spinner></bouncing-spinner>
      </section>
      <section class="placeholder" v-if="!loading && ordersToShow.length === 0">
        <p>
          U heeft nog geen opdrachten geplaatst of uw zoekopdracht heeft geen
          resultaten opgeleverd.
        </p>
      </section>
      <ul class="orders-list">
        <li
          class="order-list-item"
          v-for="(order, index) in ordersToShow"
          :key="index"
        >
          <span class="col-date" @click="getInfo(order)">{{
            order.dateSimple
          }}</span>
          <span class="col-ordernr" @click="getInfo(order)">{{
            order.orderNumber
          }}</span>
          <span class="col-project" @click="getInfo(order)">{{
            order.project
          }}</span>
          <span class="col-reference" @click="getInfo(order)">{{
            order.reference
          }}</span>
          <span class="col-product" @click="getInfo(order)">{{
            order.product
          }}</span>
          <span class="col-state" @click="getInfo(order)">{{
            order.state
          }}</span>
          <span class="col-btn">
            <popup-menu anchor-position="right">
              <template v-slot:trigger>
                <button class="kebab-btn" slot="trigger"><span></span></button>
              </template>
              <template v-if="order.repeatable && !notRepeatableByTheme">
                <menu-item @click="() => repeatOrder(order.orderId)"
                  >Printopdracht herhalen</menu-item
                >
              </template>
              <menu-item @click="() => getInfo(order)"
                >Orderbon bekijken</menu-item
              >

              <template v-if="order.repeatable">
                <menu-item @click="() => removeFiles(order)"
                  >Bestanden verwijderen</menu-item
                >
              </template>
            </popup-menu>
          </span>
        </li>
      </ul>
    </main>
  </section>
</template>

<script>
import { EventBus } from '@/eventbus/EventBus.js'
import OrderInfo from './orderinfo/OrderInfo.vue'
import Notification from '@/dialogs/Notification.vue'
import OrdersMixin from './OrdersMixin'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import SortMixin from '@/mixins/SortMixin'
import { getOrders, removeOrderFiles } from '@/features/orderHistory/OrderApi'
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue'

export default {
  data() {
    return {
      filter: '',
      ordersList: [],
      loading: true,
      curIndex: 0,
      ordersToShow: []
    }
  },
  mixins: [OrdersMixin, SortMixin],
  computed: {
    notRepeatableByTheme() {
      return this.rootStore.theme.customFields.hideRepeatOrders
    },
    orders() {
      const orders = [...this.ordersList]
      let filtered
      if (orders.length === 0) {
        filtered = []
      } else if (this.filter.length === 0) {
        filtered = orders
      } else {
        filtered = orders.filter((order) => {
          //delete order.date
          const values = Object.values(order).join('')

          console.log(values)

          return values.toLowerCase().includes(this.filter.toLowerCase())

          /* return values.find((a) => {
            return (
              typeof a === 'string' &&
              a.toLowerCase().includes(this.filter.toLowerCase())
            )
          }) */
        })
      }

      return this.sortArray(filtered.reverse())
    }
  },
  watch: {
    orders: function (val, oldVal) {
      this.ordersToShow = []
      this.curIndex = 0
      if (val.length !== 0) {
        this.loadMore()
      }
    }
  },
  methods: {
    loadMore() {
      let restLength = this.orders.length - this.ordersToShow.length
      let loadLength = restLength < 15 ? restLength : 15
      for (let i = 0; i < loadLength; i++) {
        this.ordersToShow.push(this.orders[this.curIndex])
        this.curIndex += 1
      }
    },
    getInfo(order) {
      this.$modal.show(
        OrderInfo,
        {
          orderId: order.orderId
        },
        {
          width: 730,
          height: 600,
          adaptive: true
        }
      )
    },
    downloadPdf(id) {
      location.href = `/api/v3/order-confirmation/${id}`
    },
    removeFiles(order) {
      this.$modal.show(
        ConfirmationDialog,
        {
          text:
            'Weet u zeker dat u de bestanden bij order ' +
            order.orderNumber +
            ' wil verwijderen?',
          buttons: [
            {
              title: 'Annuleren',
              class: 'pill-button secondary'
            },
            {
              title: 'Verwijderen',
              class: 'pill-button',
              handler: () => {
                removeOrderFiles(order.orderId).then(() => {
                  order.repeatable = false
                  this.$modal.hide('dialog')

                  this.ordersList.forEach((ord) => {
                    if (ord.orderId === order.orderId) {
                      ord.repeatable = false
                    }
                  })

                  this.$modal.show(
                    Notification,
                    { text: 'De bestanden zijn verwijderd' },
                    {
                      width: 380,
                      adaptive: true
                    }
                  )
                })
              }
            }
          ]
        },
        {
          width: 400,
          height: 'auto'
        }
      )
      /* this.$modal.show('dialog', {
        text:
          'Weet u zeker dat u de bestanden bij order <strong>' +
          order.orderNumber +
          '</strong><br> wil verwijderen?',
        buttons: [
          {
            title: 'Annuleren',
            class: 'pill-button secondary',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Verwijderen',
            class: 'pill-button',
            handler: () => {
              removeOrderFiles(order.orderId).then(() => {
                order.repeatable = false
                this.$modal.hide('dialog')

                this.ordersList.forEach((ord) => {
                  if (ord.orderId === order.orderId) {
                    ord.repeatable = false
                  }
                })

                this.$modal.show(
                  Notification,
                  { text: 'De bestanden zijn verwijderd' },
                  {
                    width: 380,
                    adaptive: true
                  }
                )
              })
            }
          }
        ]
      }) */
    }
  },
  mounted() {
    EventBus.on('filter-orders', (val) => {
      this.filter = val
    })
    getOrders().then((orders) => {
      orders.forEach((order) => {
        order.dateSimple = format(parseISO(order.date), 'dd-MM-yyyy')
      })
      this.ordersList = orders
      //this.loadMore()
      this.loading = false
    })

    //inf scroll shizzle
    // Detect when scrolled to bottom.
    const loadOffset = 300 //start loadMore x pixels before scroll-end
    const listElm = document.querySelector('#scroll-list')
    listElm.addEventListener('scroll', (e) => {
      if (
        listElm.scrollTop + listElm.clientHeight + 300 >=
        listElm.scrollHeight
      ) {
        this.loadMore()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/base/colors' as *;
@use '../../sass/helpers/_variables.scss' as *;

/* Column widths are declared once and shared by the header and the rows,
   so both stay aligned. */
.col-date {
  flex: 0 0 84px;
}
.col-ordernr {
  flex: 0 0 70px;
}
.col-project {
  flex: 1.2 1 0;
  min-width: 0;
}
.col-reference {
  flex: 1 1 0;
  min-width: 0;
}
.col-product {
  flex: 0 0 70px;
}
.col-state {
  flex: 0 0 86px;
}
.col-repeat-btn {
  flex: 0 0 32px;
}
.col-btn {
  flex: 0 0 28px;
  text-align: right;

  button {
    vertical-align: middle;
  }
}

.orders-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.list-header,
.order-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 4px;
}

.list-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  border-bottom: 1px solid $divider;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: $grey-m;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .clickable:hover {
    color: $text-color;
  }

  /* The rows scroll and the header does not, so both reserve the same
     scrollbar gutter to keep the columns aligned. */
  scrollbar-gutter: stable;
}

.table-container {
  overflow: auto;
  scrollbar-gutter: stable;
}

.orders-list {
  background: white;
}

.order-list-item {
  border-bottom: 1px solid $list-divider;
  transition: background-color 0.2s;
  line-height: 1.4;
  cursor: pointer;

  &:hover {
    background-color: $list-hover;
  }

  > span {
    padding: 15px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .col-repeat-btn {
    padding: 0;
  }
}

.col-ordernr {
  font-variant-numeric: tabular-nums;
}

.col-reference {
  color: $grey-m;
}

.repeat-btn {
  display: flex;
  align-items: center;
  padding: 5px;
}

.pre-loader {
  position: absolute;
  width: 180px;
  left: calc(50% - 90px);
  top: 30px;
  text-align: center;

  p {
    margin-bottom: 10px;
  }
}

.placeholder {
  padding: 24px 4px;
  color: $grey-m;
}

/* On mobile only date, order number and status remain. The other columns
   are dropped from both the header and the rows so the two stay in step. */
@media (max-width: $mobile-max-width) {
  .list-header,
  .order-list-item {
    gap: 10px;
  }

  .col-project,
  .col-reference,
  .col-product,
  .col-repeat-btn {
    display: none;
  }

  .col-date {
    flex: 0 0 84px;
  }

  .col-ordernr {
    flex: 1 1 0;
    min-width: 0;
  }

  .col-state {
    flex: 0 0 104px;
    text-align: right;
  }
}
</style>
